import _ from "lodash";
import { observer } from "mobx-react";
import React, { useCallback, useState } from "react";
import { StyleSheet } from "react-native";
import { Spacer } from "~/components/Spacer";
import { BodyText } from "~/components/V2/Text/BodyText";
import { BrandText } from "~/components/V2/Text/BrandText";
import { View } from "~/components/V2/View";
import type { PetInstance } from "~/mobx/entities/pets/Pet";
import { styleConstantsV2 } from "~/style/styleConstantsV2";
import { AnimalAvatar } from "./AnimalAvatar";
import { ButtonCircle } from "./ButtonCircle";
import { Pressable } from "./Pressable";
import type { PressableStateCallbackType } from "react-native";

const S = StyleSheet.create({
  subtitle: {
    lineHeight: 22,
  },
  title: {
    lineHeight: 34,
  },
  textContainer: { width: "100%" },
});

export const PetCard = observer(function PetCard({
  pet,
  onPress,
}: {
  pet: PetInstance;
  onPress: () => void;
}) {
  const [isPressed, setIsPressed] = useState(false);

  const resolveBackgroundColor = useCallback(
    (state: PressableStateCallbackType) => {
      if (state.pressed) {
        return styleConstantsV2.colorPrimaryHoverLight;
      }
      if (state.hovered) {
        return styleConstantsV2.colorPrimaryHoverLight;
      }

      return styleConstantsV2.colorPrimaryBg;
    },
    [],
  );

  return (
    <Pressable
      onPressIn={() => {
        setIsPressed(true);
      }}
      onPressOut={() => {
        setIsPressed(false);
      }}
      onPress={onPress}
      style={(state) => {
        return {
          backgroundColor: resolveBackgroundColor(state),
          paddingVertical: styleConstantsV2.spacing24,
          paddingHorizontal: styleConstantsV2.spacing16,
          borderRadius: styleConstantsV2.borderRadius4,
        };
      }}
    >
      <View flexDirectionRow>
        {pet.species && (
          <View flexDirectionRow>
            <AnimalAvatar specie={pet.species} />
            <Spacer large />
          </View>
        )}
        <View flex>
          <BrandText sizeH2 weightExtraBold colorBlack style={S.title}>
            {pet.name}
          </BrandText>
          <Spacer extraSmall />
          <BodyText sizeLarge weightRegular colorBlack style={S.subtitle}>
            {_.capitalize(pet.species?.name)}
          </BodyText>
        </View>
        <View justifyContentCenter alignItemsFlexEnd>
          <ButtonCircle
            iconName="chevron-right"
            size="medium"
            pointerEvents="none"
            backgroundColor={
              isPressed
                ? styleConstantsV2.colorGrey20
                : styleConstantsV2.colorWhite
            }
          />
        </View>
      </View>
    </Pressable>
  );
});
